import { useEffect } from 'react';
/* Disable native pinch zoom scale for IOS */
const usePreventPinchZoomIOS = () => {
  useEffect(() => {
    const preventZoom = (e: WheelEvent | TouchEvent) => {
      if ('ctrlKey' in e && e.ctrlKey) {
        e.preventDefault();
      }
    };

    window.addEventListener('wheel', preventZoom, { passive: false });
    window.addEventListener('touchmove', preventZoom, { passive: false });

    return () => {
      window.removeEventListener('wheel', preventZoom);
      window.removeEventListener('touchmove', preventZoom);
    };
  }, []);
};

export default usePreventPinchZoomIOS;
